import { createStore } from 'vuex'

const modules = {}
const vuexModules = require.context(
  './modules',
  true,
  /[A-Za-z0-9-_,\s]+\.(js)$/i
)

function mapModules (context) {
  const keys = context.keys()
  const values = keys.map(context)

  for (let i = 0; i < keys.length; i++) {
    const key = keys[i]
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)

    if (matched && matched.length > 1) {
      const moduleName = matched[1]
      const module = values[i].default

      if (module) {
        modules[moduleName] = values[i].default
      }
    }
  }
}

mapModules(vuexModules)

export default createStore({
  state: {
    /**
     * Kiểu người dùng (Giáo viên | Học sinh)
     */
    userTypes: {
      teacher: 'teacher',
      student: 'student'
    },
    /**
     * Kiểu người dùng hiện tại, mặc định là Giáo viên
     */
    userTypeActive: 'teacher'
  },
  mutations: {
    /**
     * @author PVThang
     * @description Đổi kiểu người dùng kèm theo clear dữ liệu
     * @param {*} state
     * @param {*} newType
     */
    setUserTypeActive (state, newType) {
      if (Object.values(state.userTypes).includes(newType)) {
        state.userTypeActive = newType
        state['auth-student/account'] = {}
        state['auth/account'] = {}
        state['auth/forgotPasswordEntity'] = {}
        state['auth/registerEntity'] = {}
        state['auth/updateOrganizationEntity'] = {}
      }
    },

    /**
     * @author PVThang
     * @description Xóa dữ liệu
     * @param {*} state
     */
    clearData (state) {
      state['auth-student/account'] = {}
      state['auth/account'] = {}
      state['auth/forgotPasswordEntity'] = {}
      state['auth/registerEntity'] = {}
      state['auth/AppUse'] = {}
    }
  },
  actions: {},
  modules: modules
})
